import {UserStore} from "./user.store";
import {observable, action} from "mobx";
import {IApiClient} from "../common/api.client";

export enum DebugPanelOperation {
	Logout = 1,
	GenerateTestPdf = 2,
}

export class DebugPanelStore {
	@observable debugPanelVisible = false;
	@observable isLoading = false;
	@observable operation: DebugPanelOperation | null = null;

	constructor(private userStore: UserStore, private apiClient: IApiClient) {}

	@action
	toggleTestingPanel = () => {
		this.debugPanelVisible = !this.debugPanelVisible;
	};

	@action
	async logout() {
		await this.userStore.logout();
	}

	@action
	async getGeneratedPdfFile() {
		this.setLoading(DebugPanelOperation.GenerateTestPdf);
		const fileContent = await this.apiClient.debugPanelClient.generateTestPdf();
		this.setLoading(null);
		return fileContent;
	}

	@action
	private setLoading(operation: DebugPanelOperation | null) {
		this.isLoading = !!operation;
		this.operation = operation;
	}
}
